import { IEventModule } from "@Modules/eventPage/root/IEventModule";
import { QUERY_PARAMS } from "@Utils";

export const getShowCompactEventPage = ({
    urlQueryParams,
}: {
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
}) => urlQueryParams?.[QUERY_PARAMS.COMPACT] === "true";
